import { HttpMethod } from '@vision/ui/enums';
import { TicketManagerApiRequest } from '../ticket-manager.api';
import { TicketManagerQueueDeleteArgs } from './queues.api.types';

const TICKET_MANAGER_INNER_LOOP_ENDPOINT = '/v2/inner_loop';

export const buildGetProjectQueuesRequest = ({ projectId }: { projectId: string }): TicketManagerApiRequest => ({
  method: HttpMethod.GET,
  url: `${TICKET_MANAGER_INNER_LOOP_ENDPOINT}/${projectId}/queues`,
});

export const buildCreateQueueRequest = ({
  name,
  ordering,
  projectId,
}: {
  name: string;
  ordering: string;
  projectId: string;
}): TicketManagerApiRequest => ({
  data: { name, ordering },
  method: HttpMethod.POST,
  url: `${TICKET_MANAGER_INNER_LOOP_ENDPOINT}/${projectId}/queues`,
});

export const buildUpdateQueueRequest = ({
  name,
  ordering,
  projectId,
  queueId,
}: {
  name: string;
  ordering: string;
  projectId: string;
  queueId: string;
}): TicketManagerApiRequest => ({
  data: { name, ordering },
  method: HttpMethod.POST,
  url: `${TICKET_MANAGER_INNER_LOOP_ENDPOINT}/${projectId}/queues/${queueId}/update`,
});

export const buildDeleteQueueRequest = ({
  projectId,
  queueId,
}: TicketManagerQueueDeleteArgs): TicketManagerApiRequest => ({
  method: HttpMethod.POST,
  url: `${TICKET_MANAGER_INNER_LOOP_ENDPOINT}/${projectId}/queues/${queueId}/delete`,
});
